define('features/overlayGameLauncher/adventureTwo/AdventureTwoModel',[
    'knockout'
], function (ko) {

    /**
     * Expose the adventure properties.
     *
     * Create the adventure in any state you want by passing in a new observable data.
     */
    return function AdventureTwoModel (AdventureTwoSummaryModel,
                                       AdventureTwoShopModel,
                                       adventureTwoObservableData) {
        var self = this;

        self.summary = ko.pureComputed(function () {
            return new AdventureTwoSummaryModel(adventureTwoObservableData.property('summary'));
        });

        self.shop = ko.pureComputed(function () {
            return new AdventureTwoShopModel(adventureTwoObservableData.property('shop'));
        });

        self.inventory = ko.pureComputed(function () {
            return adventureTwoObservableData.property('inventory')();
        });

        console.log('ADVENTURE', self);

    };

});

